function combate(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Para prevenir que as casas e apartamentos se transformem em criadouros do Aedes Aegypti é importante colocar o lixo em sacos plásticos e manter a lixeira sempre fechada.",
						"title":"Como Protejer Sua Residência",
						"image":"images/games/informs/combate/residencia/1.jpg",
					},
					{
						"text":"Também é importante limpar as calhas e encher os pratos dos vasos de plantas com areia. Garrafas e recipiente que acumulam água devem ser virados para baixo e a caixa d’água deve ser fechada;",
						"title":"Como Protejer Sua Residência",
						"image":"images/games/informs/combate/residencia/2.jpg",
					},
					{
						"text":"Instalar telas nas janelas; trocar a água e lavar o vaso das plantas aquáticas com escova, água e sabão, pelo menos uma vez por semana;",
						"title":"Como Protejer Sua Residência",
						"image":"images/games/informs/combate/residencia/3.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/combate/residencia/1.jpg"
			},
			{
				"informs":[
					{
						"text":"Utilizar roupas que minimizem a exposição da pele, proporcionando alguma proteção contra as picadas dos mosquitos principalmente durante o dia, período que são mais ativos.A dedetização também é recomendada e deve ser aplicada por profissional especializado.",
						"title":"Como Se Protejer",
						"image":"images/games/informs/combate/como_se_protejer/1.jpg",
					},
					{
						"text":"Aplicar repelentes nas áreas expostas do corpo e por cima da roupa, de acordo com a indicação de cada fabricante e, em caso de suor excessivo ou contato com a água, fazer a reaplicação.",
						"title":"Como Se Protejer",
						"image":"images/games/informs/combate/como_se_protejer/2.jpg",
					},
					{
						"text":"Repelentes ambientais e inseticidas também podem ser utilizados em ambientes frequentados por gestantes desde que cumpram as regras de registro na Anvisa e sejam obedecidos todos os cuidados e precauções descritas nos rótulos dos produtos.",
						"title":"Como Se Protejer",
						"image":"images/games/informs/combate/como_se_protejer/3.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/combate/como_se_protejer/3.jpg"
			},
			{
				"informs":[
					{
						"text":"Basta secar os lugares onde tem água parada? R: Não adianta só secar os reservatórios de água parada. Tem de limpar também. O ovo do mosquito pode se manter viável por mais de um ano, fora da água, em lugares secos.",
						"title":"Duvidas Frequentes",
						"image":"images/games/informs/combate/duvidas_frequentes/1.jpg",
					},
					{
						"text":"O mosquito da dengue pica apenas durante o dia? R: O mosquito pica principalmente durante o dia, mas se tiver oportunidade também vai picar a noite.",
						"title":"Duvidas Frequentes",
						"image":"images/games/informs/combate/duvidas_frequentes/2.jpg",
					},
					{
						"text":"Aplicar borra de café na água das plantas e sobre a terra ajuda a combater o mosquito? R: Não. A eficácia da borra de café não foi comprovada (já foi verificado na prática que a água suja de borra de café desenvolve a larva do mosquito).",
						"title":"Duvidas Frequentes",
						"image":"images/games/informs/combate/duvidas_frequentes/3.jpg",
					},
					{
						"text":"Colocar água sanitária na água ajuda a evitar as larvas? R: Ajuda. É uma das principais medidas. Colocar água sanitária na caixa d’água, na piscina, nas poças de água ajuda a evitar as larvas.",
						"title":"Duvidas Frequentes",
						"image":"images/games/informs/combate/duvidas_frequentes/4.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/combate/duvidas_frequentes/1.jpg"
			}
			
		]
	};
}

export {combate};
